<script lang="ts">
  import type { ActionData } from './$types'
  import { showLoading } from '$lib/stores/layout'
  import LoginForm from '$components/Forms/LoginForm.svelte'
  import { t } from '$lib/translations'
  import { onMount } from 'svelte'

  export let form: ActionData

  let isRecoverPasswordForm = false

  onMount(() => {
    if (form?.success === true) {
      if (form.redirect && form.type === 'login' && typeof window !== 'undefined') {
        let authStr = JSON.stringify(form.authModel)
        let date = new Date()
        date.setDate(date.getDate() + 7)
        let expires = date.toUTCString()
        document.cookie = `pb_auth=${authStr};expires=${expires}${process.env.NODE_ENV !== 'development' ? ';Secure;SameSite=none' : ''}`
        showLoading.set(true)
        location.href = form?.redirect
      }

      if (form?.success === true && form.type === 'recover_password') {
        isRecoverPasswordForm = true
      }
    }
  })
</script>

<section class="grid grid-cols-1 lg:grid-cols-2 gap-4 items-center img-background w-full flex-grow">
  <div class="py-4 lg:col-start-2">
    <LoginForm
      {isRecoverPasswordForm}
      recoverPasswordSuccess={form?.type === 'recover_password' && form?.success}
      errorMessage={form?.success === false ? $t(`common.${form?.message}`) || $t('common.unknown_error') : undefined}
    />
  </div>
</section>

<style>
  /* Style for mobile only: */
  @media (max-width: 1024px) {
    .img-background {
      height: calc(100dvh - 96px) !important;
    }
  }

  .img-background {
    background-image: url('/login-image.webp');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    background-attachment: scroll;
    justify-content: space-evenly;
  }
</style>
